import { SxProps, Theme } from '@mui/material';
import { DESKTOP_MIN_WIDTH } from '../constants';

export const productRatingsSx = (isProductList = false): SxProps<Theme> => ({
	height: '15px',
	flexShrink: 0,
	alignSelf: 'flex-start',

	[`@media (min-width: ${DESKTOP_MIN_WIDTH}px)`]: {
		height: '20px',
	},
	'& p': {
		...(isProductList && {
			color: 'grey.300',
			fontSize: '12px',
		}),
	},
});

export const ratingCardSx: SxProps<Theme> = {
	mb: 0,
};
